import * as React from 'react';

import {NothingFoundEmptyState} from 'shells/empty-states/nothing-found-empty-state';
import {Body} from 'shells/typography/body';

import type {
    GetSearchResultsByType_search_quickResults_accountResults as AccountResult,
    GetSearchResultsByType_search_quickResults_contactResults as ContactResult,
    GetSearchResultsByType_search_quickResults_leadResults as LeadResult,
} from 'nutshell-graphql-types';

import {LoadingState} from './loading-state';
import {SearchSections} from './search-sections';

type Props = {
    searchValue: string;
    setSearchValue: (searchValue: string) => void;
    isLoading: boolean;
    hasSearchResults: boolean;
    hasRecentResults: boolean;
    setIsSearchBarFocused: (isSearchBarFocused: boolean) => void;
    accountResults: Array<AccountResult>;
    contactResults: Array<ContactResult>;
    leadResults: Array<LeadResult>;
    recentResults:
        | {
              accounts: Array<AccountResult>;
              contacts: Array<ContactResult>;
              leads: Array<LeadResult>;
          }
        | null
        | undefined;
    hasTyped: boolean;
};

export function PopoverContent(props: Props) {
    if (props.isLoading) {
        return <LoadingState hasTyped={props.hasTyped} />;
    } else if (props.searchValue) {
        if (!props.hasSearchResults) {
            return (
                <NothingFoundEmptyState
                    title='No search results'
                    subtitle='No companies, people, or leads were found.'
                />
            );
        } else {
            return (
                <SearchSections
                    showSearchAll={true}
                    accountResults={props.accountResults}
                    contactResults={props.contactResults}
                    leadResults={props.leadResults}
                    setIsSearchBarFocused={props.setIsSearchBarFocused}
                    setSearchValue={props.setSearchValue}
                    searchValue={props.searchValue}
                />
            );
        }
    } else if (!props.hasRecentResults) {
        return (
            <NothingFoundEmptyState
                title='Nothing to see...yet!'
                subtitle='As soon as you start looking around Nutshell, your recently viewed companies, people, and leads will appear.'
            />
        );
    } else {
        return (
            <div className='flex flex-dir-col gap-16 full-width full-height'>
                <div className='px-16'>
                    <Body color='light'>Recently viewed</Body>
                </div>
                <SearchSections
                    showSearchAll={false}
                    accountResults={(props.recentResults && props.recentResults.accounts) || []}
                    contactResults={(props.recentResults && props.recentResults.contacts) || []}
                    leadResults={(props.recentResults && props.recentResults.leads) || []}
                    setIsSearchBarFocused={props.setIsSearchBarFocused}
                    searchValue={props.searchValue}
                    setSearchValue={props.setSearchValue}
                />
            </div>
        );
    }
}
